import React, { useState } from "react";
import { Wand2, X } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { AdvisorChat } from "./AdvisorChat";
import { useLang } from "../i18n/LanguageContext";

export const AdvisorWidget = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-testid="floating-advisor-button" onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full pl-4 pr-5 py-3 btn-glow border-0 font-medium animate-glow-pulse">
        <Wand2 className="h-5 w-5" />
        <span className="hidden sm:inline">{t("advisor.floating")}</span>
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="glass border-border w-[95vw] sm:w-[460px] flex flex-col">
          <SheetHeader>
            <SheetTitle className="font-display text-xl flex items-center gap-2"><Wand2 className="h-5 w-5 text-cyanx" /> {t("advisor.title")}</SheetTitle>
          </SheetHeader>
          <div className="flex-1 min-h-0 mt-4">
            <AdvisorChat layout="stacked" />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
